/**
 *  All api related to articles
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchArticlesCategories(options = {}) {
  const { page = 1, ...others } = options
  const params = {
    page,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchArticlesCategories',
    () => source.cancel('fetchArticlesCategories: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'article_categories',
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      articlesCategories: data.articleCategories,
      pagination: data.articleCategoriesPagination,
      next: _.get(data, 'articleCategoriesPagination.nextPage') > page
        ? () => fetchArticlesCategories({ page: page + 1, ...others })
        : null,
      count: _.get(data, 'articleCategoriesPagination.totalCount')
    }))
}

